import { handleErrorWithSentry, replayIntegration } from '@sentry/sveltekit';
import * as Sentry from '@sentry/sveltekit';

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (dsn) {
	Sentry.init({
		dsn,
		release: import.meta.env.VITE_GIT_SHA || 'unknown',
		environment: import.meta.env.MODE || 'development',
		tracesSampleRate: 0.1,
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
		integrations: [replayIntegration()]
	});
}

export const handleError = handleErrorWithSentry();
